<template>
  <div class="parametros">
    <h1>Parámetros del Sistema</h1>
    
    <!-- Tabla de parámetros -->
    <div class="d-flex justify-content-end mb-3">
      <button @click="addParametro" class="btn btn-primary">
        <i class="bi bi-plus-circle me-1"></i> Nuevo Parámetro
      </button>
    </div>
    
    <div class="alert alert-info" v-if="loading">Cargando parámetros...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <div class="table-responsive" v-if="!loading && !error && parametros && parametros.length > 0">
      <table class="table table-striped table-hover">
        <thead class="table-dark">
          <tr>
            <th>Clave</th>
            <th>Valor</th>
            <th>Descripción</th>
            <th>Tipo</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="parametro in parametros" :key="parametro.ParametroClave">
            <td>{{ parametro.ParametroClave }}</td>
            <td>{{ parametro.Valor }}</td>
            <td>{{ parametro.Descripcion }}</td>
            <td>{{ parametro.Tipo }}</td>
            <td>
              <div class="btn-group">
                <button @click="editParametro(parametro)" class="btn btn-sm btn-warning me-1">
                  <i class="bi bi-pencil"></i> Editar
                </button>
                <button @click="confirmDelete(parametro)" class="btn btn-sm btn-danger">
                  <i class="bi bi-trash"></i> Eliminar
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="alert alert-info" v-if="!loading && !error && (!parametros || parametros.length === 0)">
      No hay parámetros registrados. Haga clic en 'Nuevo Parámetro' para agregar uno.
    </div>

    <div class="mt-4">
      <router-link to="/" class="btn btn-secondary">
        <i class="bi bi-arrow-left me-1"></i> Volver al Menú
      </router-link>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import ParametrosViewController from '../controllers/ParametrosViewCtrl.js';

export default {
  name: 'ParametrosView',
  components: {},
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new ParametrosViewController()
    }
  },
  computed: {
    parametros() {
      return this.controller.getParametros();
    },
    loading() {
      return this.controller.isLoading();
    },
    error() {
      return this.controller.getCurrentError();
    }
  },
  created() {
    this.controller.initialize();
  },
  methods: {
    fetchParametros() {
      this.controller.loadParametros();
    },
    addParametro() {
      this.$router.push('/parametros/add');
    },
    editParametro(parametro) {
      this.$router.push(`/parametros/edit/${parametro.ParametroClave}`);
    },
    confirmDelete(parametro) {
      console.log('Iniciando confirmación de eliminación para:', parametro.ParametroClave);
      
      // Usar SweetAlert para la confirmación
      this.$alert.confirm(
        `¿Está seguro que desea eliminar el parámetro "${parametro.ParametroClave}"?`,
        'Confirmar eliminación',
        { icon: 'warning' }
      ).then((result) => {
        console.log('Resultado de confirmación:', result);
        
        if (result.isConfirmed) {
          // Si el usuario confirmó, proceder con la eliminación
          this.deleteParametro(parametro);
        }
      });
    },
    async deleteParametro(parametro) {
      try {
        const response = await this.controller.deleteParametro(parametro);
        
        // Usar el manejador de respuestas MgkMessage
        this.$mgkResponse.handleResponse(response).then(() => {
          console.log('Recargando lista de parámetros después de eliminación');
          // Recargar la lista de parámetros después de mostrar el mensaje
          this.controller.reloadParametros();
        });
      } catch (error) {
        this.$alert.error('No se pudo eliminar el parámetro. Por favor, intente nuevamente.');
      }
    }
  }
}
</script>
